import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const infraCreatorPlugin = createPlugin({
  id: 'infra-creator',
  routes: {
    root: rootRouteRef,
  },
});

export const InfraCreatorPage = infraCreatorPlugin.provide(
  createRoutableExtension({
    name: 'InfraCreatorPage',
    component: () =>
      import('./components/ResourceSelector').then(m => m.ResourceSelector),
    mountPoint: rootRouteRef,
  }),
);
export const ResourceCreatorPage = infraCreatorPlugin.provide(
  createRoutableExtension({
    name: 'ResourceCreatorPage',
    component: () => import('./components/Resource').then(m => m.Resource),
    mountPoint: rootRouteRef,
  }),
);
export const CloudSqlPage = infraCreatorPlugin.provide(
  createRoutableExtension({
    name: 'CloudSqlPage',
    component: () => import('./components/CloudSql').then(m => m.CloudSql),
    mountPoint: rootRouteRef,
  }),
);

export const RedisPage = infraCreatorPlugin.provide(
  createRoutableExtension({
    name: 'RedisPage',
    component: () => import('./components/Redis').then(m => m.Redis),
    mountPoint: rootRouteRef,
  }),
);
